
import { Component, OnInit, Input, ViewChild, ChangeDetectorRef, EventEmitter, Output, HostListener, Pipe, PipeTransform, OnChanges } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { UntypedFormControl, FormGroup } from '@angular/forms';
import { jsonParse, cloneArray } from 'src/app/app.component';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { HideOption, HTMLFormatter, stripHtmlTags } from '../dynamic-form/dynamic-form.component';
import { CvLocationComponent } from '../cv-location/cv-location/cv-location.component';
import { CvMapComponent } from '../cv-location/cv-map/cv-map.component';
import { storage_url } from '../../functions/shared-functions';


@Component({
  selector: 'tm-multi-select',
  templateUrl: './tm-multi-select.component.html',
  styleUrls: ['./tm-multi-select.component.scss'],
  providers: [HideOption, HTMLFormatter]
})
export class TmMultiSelectComponent implements OnInit {
  @Input() options = [];
  @Input() form_group;
  @Input() label;
  @Input() form_control;
  @Input() title_property = "title";
  @Input() id_property = "id"
  @Input() placeholder = "<- -Select- ->";
  @Input() selected_input;
  @Input() mandatory;
  @Input() show_mandatory;
  @Input() float_label;
  @Input() disabled;
  @Input() master_obj;
  @Input() enable_virtual_scroll;
  @Input() data;
  @Input() label_block;
  @Input() master_form_code;
  @Input() hide_label;


  @Input() min_length;
  @Input() max_length;
  @Input() maxLength;
  @Input() minLength;
  @Input() maxValue;
  @Input() minValue;
  @Input() prefix_label;
  @Input() suffix_label;
  @Input() label_class;
  @Input() label_css;
  @Input() parent_functions;
  @Input() onChangeFunc;
  @Input() design_pattern;
  @Input() control_class;
  @Input() control_css;
  @Input() label_width;
  @Input() control_width;
  @Input() label_overflow;
  @Input() addFunc
  @Input() suffix_btn_icon
  @Input() description: any = {}
  @Input() secondary_suffix_btn;
  @Input() secondary_suffix_title;
  @Input() enable_select_all
  @Input() label_action_type
  @Input() label_action_title
  @Input() appearance
  @Input() enable_child_options;
  @Input() default_readonly;
  @Input() optionInnerHTML;
  @Input() no_data_found_message = 'No data found!';
  fetching_masters = false;

  @Input() verified_status;
  @Input() notes;
  @Input() verification_required;
  @Input() reason;


  @Input() auto_addition = 0;



  @Output() selected_obj = new EventEmitter<any>();
  @Output() fetchEntries = new EventEmitter<any>();

  @ViewChild('form', { static: true }) form;
  @ViewChild(CdkVirtualScrollViewport) options_list_view: CdkVirtualScrollViewport;
  @ViewChild('search_input') search_input;

  show_list: boolean = false;
  filtered_options = [];

  search = new UntypedFormControl();
  last_value;
  view_port: any;
  inner_height: number;
  top: number = 0;
  left: number = 0;
  filter_len: boolean = false;
  arrow_key_location = 0;
  filter_keyword_delay: boolean = false;
  delayed_keyword;
  code = [];
  select_all: boolean = false;
  display_overlay = 0;

  selected_options = [];
  selected_options_title = [];
  selected_options_code = [];

  emit = true;
  skip: number = 0;
  take: number = 0;
  total_count;

  random_id = 'tallint_multi_select' + Math.floor((Math.random() * 10000) + 1) + Date.now();
  onSelectRef = this.onSelect.bind(this)
  current_icon_obj: any;
  container_width: number = 300;
  field_width: number = 300;
  is_display_block: boolean = false;
  wait_till_content_loading: boolean;

  google_storage = storage_url

  constructor(
    private change_detector_ref: ChangeDetectorRef,
    private HideOption: HideOption,
    private dialog: MatDialog,
    private HTMLFormatter: HTMLFormatter,
    private notification_svc: NotificationService
  ) {
  }

  init() {
    // this.min_length = 2;
    // this.max_length = 3;

    if (!(this.min_length)) {
      this.min_length = 0;
    }
    if (!(this.max_length)) {
      this.max_length = 99999999;
    }

    this.data = jsonParse(this.data);
    this.options = jsonParse(this.options);
    this.options = this.HideOption.transform(this.options);

    try {
      if (this.options && this.options.length) {
        for (let i = 0; i < this.options.length; i++) {
          if (this.options[i][this.title_property]) {
            this.options[i][this.title_property] = stripHtmlTags(this.HTMLFormatter.transform(this.options[i][this.title_property]));
          }
        }
      }
    }
    catch (err) {

    }

    if (!this.show_list) {
      this.search.reset();

      if (!this.form_group.get([this.form_control]).value) {
        this.search.reset();
      }
    }
    // if (this.form_group.get([this.form_control]).value) {
    //   // this.search.reset();
    //   this.form_group.get([this.form_control]).value = jsonParse(this.form_group.get([this.form_control]).value);
    // }

    this.filtered_options = this.options;


    this.initializeValue();

    this.setVirtualScroll();

    if (this.disabled) {
      this.disable(this.disabled);
    }
    setTimeout(() => {
      this.wait_till_content_loading = true;
    }, 1000)
  }
  ngAfterViewInit() {
    // try {
    //   let el = document.getElementById(this.random_id);
    //   this.field_width = el.offsetWidth;
    //   if (this.field_width > (window.innerWidth / 2)) {
    //     this.is_display_block = false;

    //     this.change_detector_ref.detectChanges();
    //   }
    // }
    // catch (err) {
    //   this.field_width = 300;
    //   this.is_display_block = true;

    // }
  }

  calculatePosition() {
    let top = document.getElementById(this.random_id).getBoundingClientRect().top;
    let left = document.getElementById(this.random_id).getBoundingClientRect().left;

    this.container_width = document.getElementById(this.random_id).offsetWidth;
    if (this.container_width <= 300) {
      this.container_width = 300;
    }

    if (top > window.innerHeight / 2) {
      this.top = top - 195;
    }
    else {
      this.top = document.getElementById(this.random_id).getBoundingClientRect().top + 45;
    }
    if (left + 300 > (window.innerWidth)) {
      this.left = window.innerWidth - 325;
    }
    else {
      this.left = left;
    }
  }


  ngOnInit() {
    this.init();
  }

  ngOnChanges(ev) {
    if (ev.options && !ev.options.firstChange) {
      this.selected_options_code = [];
      this.selected_options = [];
      this.selected_options_title = [];
      console.log(ev.options.currentValue)
      this.init();
      this.fetching_masters = false;
    }
    if (ev.data && !ev.data.firstChange) {
      if (this.options && this.options.length) {

        if (this.options.filter(data => data.option_selected).length > 0) {
          this.selected_options_code = [];
          this.selected_options = [];
          this.selected_options_title = [];
          this.options.forEach(op => {
            op['option_selected'] = false;
          })
        }
      }
      try {
        if (!ev.data.currentValue || ev.data.currentValue && ev.data.currentValue.length == 0) {
          this.select_all = false
        }
      }
      catch (err) {
        console.log(err)
      }

      this.initializeValue();
    }
    if (ev.disabled) {
      this.disable(ev.disabled.currentValue)
    }

    // if (ev.data && !ev.data.firstChange && ev.data.previousValue && ev.data.previousValue.length && !(ev.data.currentValue && ev.data.currentValue.length)) {
    //   if (this.selected_options) {
    //     for (let index = 0; index < this.selected_options.length; index++) {
    //       this.selected_options[index].option_selected = false;
    //     }
    //     this.select_all = false;
    //   }

    //   this.selected_options_code = [];
    //   this.selected_options = [];
    //   this.selected_options_title = [];
    // }
  }

  ngOnDestroy() {
  }

  disable(disable_flag) {
    if (disable_flag) {
      // this.search.disable();
      // this.form_group.get(this.form_control).disable()
    }
    else {
      this.search.enable();
      this.form_group.get(this.form_control).enable()
    }
  }

  showList(event) {
    if (!this.disabled) {
      try {
        if (!this.show_list) {
          this.calculatePosition();
          this.display_overlay = 1;
          this.show_list = true;
          this.filtered_options = this.options;
          // this.filter();
          // setTimeout(() => {
          //   this.setClickListener();
          // }, 100)
          event.target.select();

          // this.hidden_input.nativeElement.focus();
        }
      }
      catch (err) {

      }
      return true;
    }
  }

  setClickListener() {
    document.onclick = (ev) => {

      this.hideList(ev);
    }
  }

  destroyClickListener() {
    document.onclick = null;
  }

  checkForTab(ev) {

    if (ev.key == 'Tab') {
      this.hideList();
    }
  }


  searchKeyPress(event) {
    switch (event.keyCode) {
      case 38: //up-arrow
        this.moveInList(-1);
        break;

      case 40: //down-arrow
        this.moveInList(1);
        break;

      case 13: //enter
        {
          if (this.show_list) {
            if (this.filtered_options && this.filtered_options[this.arrow_key_location]) {
              this.onSelect(this.filtered_options[this.arrow_key_location]);
            }
          }
        }
        break;

      case 9: //tab
        // this.hideList();
        break;

      case 27: //escape
        this.hideList();
        break;

      default: //other keys

        this.filter(event);
    }
  }

  filter(event?) {
    console.log(event)
    this.showList(event);
    let CustomAddition = this.search && this.search.value ? this.search.value : '';
    let filter = this.search && this.search.value ? this.search.value.toLowerCase() : '';
    this.delayed_keyword = filter;
    if (this.enable_virtual_scroll) {
      if (!this.filter_keyword_delay) {
        this.getMasters(0, 1000, filter);
      }
    }
    else {
      if (filter) {
        this.filtered_options = [];
        if (this.options)
          for (let i = 0; i < this.options.length; i++) {
            let option = this.options[i];
            if (option && option[this.title_property]) {
              if (option[this.title_property].toLowerCase().indexOf(filter) > -1) {
                this.filtered_options.push(option);
              }
            }
          }
        if (this.filtered_options.length == 0 && this.auto_addition) {
          let obj: any = {}
          if (this.id_property == this.title_property) {
            obj[this.id_property] = CustomAddition;
            obj[this.title_property] = CustomAddition;
          }
          else {
            obj[this.id_property] = 0;
            obj[this.title_property] = CustomAddition;
          }
          this.filtered_options = [obj]
        }
      }
      else {
        this.filtered_options = this.options;
      }
    }
  }

  moveInList(val) {
    this.arrow_key_location = this.arrow_key_location + val;

    if (this.arrow_key_location >= this.filtered_options.length) {
      this.arrow_key_location = this.filtered_options.length - 1;
    }
    else if (this.arrow_key_location <= 0) {
      this.arrow_key_location = 0;
    }
    if (this.options_list_view) {
      this.options_list_view.scrollToIndex(this.arrow_key_location);
    }
  }

  hideList(ev?) {
    if (this.show_list && !ev || !(ev && document.getElementById(this.random_id) && (document.getElementById(this.random_id).contains(ev['relatedTarget']) || document.getElementById(this.random_id).contains(ev['target'])))) {
      this.show_list = false;
      this.nested_menu_track = {};
      this.search.reset();
      this.display_overlay = 0;
      this.form_group.get([this.form_control]).markAsTouched();

      this.destroyClickListener();
      this.change_detector_ref.detectChanges()
    }
  }

  onSelect(selected_option) {
    if (this.filtered_options) {
      this.setValue(selected_option, 1);
      this.setValueToFormControl();

      //hide list after selection of an option
      // this.hideList();
      this.search_input.nativeElement.focus();
    }
  }
  selectAll() {
    this.select_all = !this.select_all;
    this.selected_options_code = [];
    this.selected_options_title = [];
    this.selected_options = [];
    this.filtered_options.forEach(op => {
      if (this.select_all) {
        op['option_selected'] = true;
        this.selected_options_code.push(op[this.id_property])
        this.selected_options_title.push(op[this.title_property])
        this.selected_options.push(op)
      }
      else {
        op['option_selected'] = false;
      }
    })

    this.setValueToFormControl();
    this.selected_options.forEach(option => {
      this.options.forEach(op => {
        if (option[this.id_property] == op[this.id_property]) {
          op['option_selected'] = true;
        }
      })
    })
    this.selected_obj.emit(this.selected_options)
    console.log(this.filtered_options)
  }
  setValueToFormControl() {
    if (this.selected_options_code.length == this.options.length) {
      this.select_all = true;
    }
    else {
      this.select_all = false;
    }
    this.form_group.get([this.form_control]).setValue(this.selected_options_code);
  }

  setValue(selected_option, flag?) {
    if (selected_option) {
      if (selected_option.option_selected && flag) {
        if (this.auto_addition) {
          this.clearValue(null, this.selected_options_code.indexOf(selected_option[this.title_property]));
        }
        else {
          this.clearValue(null, this.selected_options_code.indexOf(selected_option[this.id_property]));
        }
      }
      else {
        if (this.selected_options_code && typeof this.selected_options_code == 'object' && this.selected_options_code.length <= this.max_length) {
          if (this.selected_options_code.indexOf(selected_option[this.id_property]) == -1 || selected_option[this.id_property] == 0) {
            this.selected_options_code.push(selected_option[this.id_property]);
            this.selected_options_title.push(selected_option[this.title_property]);
            this.selected_options.push(selected_option);
            console.log(this.selected_options)
            if (this.auto_addition) {
              if (this.id_property == this.title_property) {
                if (this.options.findIndex(data => data[this.title_property] == selected_option[this.title_property]) < 0) {
                  let obj = {}
                  obj[this.id_property] = selected_option[this.id_property];
                  obj[this.title_property] = selected_option[this.title_property];
                  obj['option_selected'] = true;
                  this.options.push(obj)
                  this.options = [...this.options]
                }
              }
              else {
                if (this.options.findIndex(data => data[this.title_property] == selected_option[this.title_property]) < 0) {
                  let obj = {}
                  obj[this.id_property] = 0;
                  obj[this.title_property] = selected_option[this.title_property];
                  obj['option_selected'] = true;
                  this.options.push(obj)
                  this.options = [...this.options]
                }
              }
            }
            this.selected_obj.emit(this.selected_options);
          }
          selected_option.option_selected = true;
        }
        else {
          this.notification_svc.error('Maximum length ' + this.max_length + ' has exceeded', 'Close', 5000)

          // this.notification_svc.snackbar('Minimum length must be' +this.min_length + 'entries', "Close", 5000);

        }
      }
    }
    else {
      console.log('no value')
      this.clearAll(null);
    }
  }

  clearValue(ev, index) {
    if (this.selected_options && this.selected_options[index]) {
      this.selected_options[index].option_selected = false;
      if (this.auto_addition) {
        let i = this.options.findIndex(data => data[this.title_property] == this.selected_options[index][this.title_property])
        if (i > -1) {
          this.options[i].option_selected = false;
        }

      }
      this.selected_options_code.splice(index, 1);
      this.selected_options_title.splice(index, 1);
      this.selected_options.splice(index, 1);
      this.selected_obj.emit(this.selected_options);

      this.setValueToFormControl();
    }
  }


  initializeValue() {
    let value = this.form_group.get([this.form_control]).value;
    let found = 0;
    if (typeof value == 'string') {
      value = jsonParse(value);
    }
    if (value && typeof value != 'object') {
      value = [value];
    }
    if (value && value.length) {
      value.forEach(data => {
        if (this.options && this.options.length) {
          let index = this.options.findIndex(op => op[this.id_property] == data);
          if (index > -1) {
            this.setValue(this.options[index])
          }
        }

      })
    }


    let checkForChildren = (option) => {
      let element = option;
      if (value.indexOf(element[this.id_property]) > -1) {
        this.setValue(element);
        if (this.selected_options.length == value.length) {
          found = 1;
        }
      }

      if (option && option.children && option.children.length) {
        for (let i = 0; i < option.children.length; i++) {
          let elem = option.children[i];
          if (checkForChildren(elem)) {
            return 1
          }
        }
      }

      return found
    }
    if (!value || (typeof value == 'object' && value.length >= 0)) {
      this.form_group.get([this.form_control]).patchValue(value);

      if (this.filtered_options && value && value.length) {
        for (let index = 0; index < this.filtered_options.length; index++) {
          if (checkForChildren(this.filtered_options[index])) {
            break;
          }
          // let element = this.filtered_options[index];
          // if (value.indexOf(element[this.id_property]) > -1) {
          //   this.setValue(element);
          //   if (this.selected_options.length == value.length) {
          //     found = 1;
          //     break;
          //   }
          // }
        }
      }
    }
    // if (!found) {

    //   this.setValue(null);
    // }
  }

  onSelectNone(ev) {
    this.show_list = false;
  }

  minMaxCheck(min_max_flag) {
    let value = this.form_group.get([this.form_control]).value;
    if (this.min_length && (min_max_flag == 1 || min_max_flag == 3)) {
      if (value && value.length && value.length >= this.min_length) {
        this.notification_svc.snackbar('Minimum length must be ' + this.min_length + ' entries', "Close", 5000);
      }
    }
    else if (this.max_length && (min_max_flag == 2 || min_max_flag == 3)) {
      if (value && value.length && value.length <= this.max_length) {
        this.notification_svc.snackbar('Maximum length ' + this.max_length + ' has exceeded', 'Close', 5000)
      }
    }

  }

  getMasters(skip, take, search) {
    search = search ? search : '';
    this.filter_keyword_delay = true;
    this.fetching_masters = true;
    setTimeout(() => {
      this.fetchEntries.emit({ 'skip': skip, 'take': take, 'search': this.delayed_keyword || '' });
      this.filter_keyword_delay = false;
    }, 900);
    setTimeout(() => {
      this.emit = true;
    }, 1000)
  }

  getNextBatch(e) {
    //console.loge);
    if (this.enable_virtual_scroll) {
      if (e > 0) {
        if (this.emit && this.options) {
          if (e >= Math.floor(this.options.length * 0.90)) {
            if (this.skip <= this.total_count) {
              // this.skip = this.take + 1;
              this.skip += this.take;
              this.getMasters(this.skip, this.master_obj.take, this.search.value);
              this.take += this.master_obj.take;
              this.emit = false;
            }
          }
        }
      }
    }
  }

  showCalendar(item?) {
    console.log(item)
    let calenders = []
    if (this.options && this.options.length) {
      calenders = this.options.filter(op => op.calendarUrl && op.calendarUrl != '0')
    }
    // this.dialog.open(CalendarIntegrationComponent, {
    //   width: '80%',
    //   height: '100%',
    //   maxWidth: '90vw',
    //   data: {
    //     avl_users: calenders,
    //     current_user: item,
    //     name: item ? item[this.title_property] : null
    //   }
    // })
  }
  iconClickFunc(func, item) {
    try {
      this.current_icon_obj = item;
      eval(func);
    } catch (err) {
      console.log(err);
    }
  }
  setVirtualScroll() {
    if (this.enable_virtual_scroll) {
      if (this.master_obj && this.master_obj.take) {
        const obj_take = this.master_obj.take;
        this.take = obj_take;
        this.total_count = this.master_obj.total_count || this.master_obj.totalcount;
      }
      else {
        this.take = 100;
      }
    }
  }

  clearAll(ev) {
    if (this.selected_options) {
      for (let index = 0; index < this.selected_options.length; index++) {
        this.selected_options[index].option_selected = false;
      }
    }

    this.selected_options_code = [];
    this.selected_options = [];
    this.selected_options_title = [];
    this.selected_obj.emit(this.selected_options);
    this.setValueToFormControl();
  }
  suffixButtonClicked(type?) {
    if (this.addFunc) {
      try {
        this.addFunc(type);
      }
      catch (err) {
        console.log(err)
      }
    }
  }

  openAddMasterModal() {
    let setOptionRef = this.setOptions.bind(this)
    // addMasters(this.dialog, this.id_property, this.title_property, setOptionRef, this.master_form_code);
  }

  setOptions(res) {
    let value;
    try {
      if (res && res.length) {
        value = cloneArray(res)
        for (let i = 0; i < res.length; i++) {
          const ele = res[i];
          if (this.options)
            for (let j = 0; j < this.options.length; j++) {
              const opt = this.options[j]
              if (ele[this.id_property] == opt[this.id_property]) {
                this.options[j] = res[i];
                res.splice(i, 1)
                break;
              }
            }
        }
        let a = [];
        if (this.form_group.get([this.form_control]).value && (this.form_group.get([this.form_control]).value).length) {
          a.push(...(this.form_group.get([this.form_control]).value))

        }
        if (this.enable_virtual_scroll) {
          for (let i = 0; i < this.selected_options.length; i++) {
            for (let j = 0; j < res.length; j++) {
              if (res[j]['code'] == this.selected_options[i]['code']) {
                this.selected_options[i]['title'] = res[j]['title']
              }
            }
          }
          let selected_option;
          selected_option = JSON.parse(JSON.stringify(this.selected_options));
          if (this.options.length) {
            for (let i = 0; i < this.options.length; i++) {
              // if (this.selected_options_code.indexOf(this.options[i]['code']) > -1) {
              for (let j = 0; j < selected_option.length; j++) {
                if (this.options[i]['code'] == selected_option[j]['code']) {
                  this.options[i] = selected_option[j];
                  this.selected_options.splice(j, 1)
                }
              }
              // }
            }
          }
          this.options.push(...this.selected_options)

        }
        this.clearAll(null);
        this.search.reset();

        let arr = cloneArray(this.options);
        this.options = [];
        this.options.push(...arr, ...res);
        this.filtered_options = this.options;

        for (let i = 0; i < value.length; i++) {
          a.push(value[i].code)
        }
        let final_value = []
        a.filter((item, index) => {
          if (a.indexOf(item) === index) {
            final_value.push(item)
          }
        });
        this.form_group.get([this.form_control]).patchValue(final_value);
        this.init()
        // res.forEach(res=>{
        //   this.options
        // })
      }
    } catch (error) {
      console.log(error)
    }
  }

  show_child_option;
  child_option;
  nested_menu_track = {}
  checkChildOption(option, ev) {
    if (option && option.children && option.children.length) {
      ;
      this.child_option = option.children;
      this.show_child_option = true;
      setTimeout(() => {
        // let top;
        // top = ev.clientY - ev.layerY + 15;
        this.nested_menu_track['top'] = this.top;
        this.nested_menu_track['left'] = (screen.width - 450) > (ev.clientX - ev.layerX + 305) ? (ev.clientX - ev.layerX + 305) : (ev.clientX - ev.layerX - 305);
        this.nested_menu_track['display_flag'] = true;
        this.nested_menu_track['header'] = option.header;
        // this.nested_menu_track['sub_menu'] = this.nested_menu_track['sub_menu'] ? this.nested_menu_track['sub_menu'] : {};
        this.nested_menu_track['sub_menu'] = {};
      })
    }
    else {
      this.show_child_option = false
    }
  }
}


// @Pipe({
//   name: 'SelectComponentPipe'
// })
// export class SelectComponentPipe implements PipeTransform {
//   transform(code: any, options: any[]): string {
//     let out_str;
//     if (typeof code != 'object') {

//       options.forEach(opt => {
//         if (opt.code && code == opt.code) {
//           out_str = opt.title || '';
//           return;
//         }
//       })
//       return out_str || '';
//     }
//   }
// }



@Pipe({
  name: 'TMSelectIconCondition'
})
export class TMSelectIconCondition implements PipeTransform {
  transform(option: any, icon: any): boolean {
    let out_str;
    try {
      if (icon && icon.condition && eval(icon.condition)) {
        return true;
      }
      else
        return false;
    }
    catch (err) {
      return true;
    }
  }
}
